import './style.scss';

import cn from 'classnames';
import React, { useCallback } from 'react';

import { ENetwork, web3Configs } from 'web3';

import { BaseSelectField } from '../base/BaseSelectField';

interface INetwork {
  label: string;
  network: ENetwork;
}

interface ISelectNetworkFieldProps {
  label?: string;
  placeholder?: string;
  items: INetwork[];
  selectedItem?: INetwork;
  onSelectItem: (v: INetwork | undefined) => void;
  disabled?: boolean;
  errorMessage?: string;
  comment?: string;
}

const SelectNetworkField: React.FC<ISelectNetworkFieldProps> = ({
  label,
  placeholder,
  items,
  selectedItem,
  onSelectItem,
  errorMessage,
  comment,
  disabled = false,
}) => {
  const renderItem = useCallback(
    (item: INetwork) => {
      const isItemSelected = selectedItem && item.network === selectedItem.network;

      const config = web3Configs[item.network];

      return (
        <div className={cn('mm-select-network-field-item', { _selected: isItemSelected })}>
          <img src={config.logo} alt={config.label} className="network-image" />
          <span>{item.label}</span>
        </div>
      );
    },
    [selectedItem],
  );

  return (
    <BaseSelectField
      label={label}
      placeholder={placeholder}
      items={items}
      disabled={disabled}
      selectedItem={selectedItem}
      onSelectItem={onSelectItem}
      renderItem={renderItem}
      renderSelectedItem={renderItem}
      errorMessage={errorMessage}
      comment={comment}
    />
  );
};

export { SelectNetworkField };
